import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
// import { io } from 'socket.io-client';
import io from 'socket.io-client';
import { ConfigService } from '../common/config.service';



@Injectable({
  providedIn: 'root'
})
export class SocketService {

  driver!: Subject<string>
  socket: any;
  uri : string = "";

  private messageSubject = new Subject<any>();
  public message$ = this.messageSubject.asObservable();

  private socketConnectedSubject = new BehaviorSubject<boolean>(false);
  public socketConnected$ = this.socketConnectedSubject.asObservable();

  constructor(
    private configServ: ConfigService,
  ) {
   this.uri = this.configServ.socketBaseUrl
  }


  initSocket(access_token: string | null): void {

    if (!this.uri) {
      this.uri = this.configServ.socketBaseUrl;
    }
    if (this.socket) {
      if (this.socket.connected) {
        this.socketConnectedSubject.next(true); // Emit current state
      }
      return;
    }

    this.socket = io(this.uri, {
      query: {
        "access_token": access_token
      }
    });

    this.socket.on('connect', () => {
      this.socketConnectedSubject.next(true);
    });

    this.socket.on('receiveMessage', (data: any) => {
      this.messageSubject.next(data);
    });
  }
  listen(eventName: string) : Observable<string> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data: any) => {
        subscriber.next(data);
      });
    });
  }

  testPing() : Observable<string>{
    return new Observable((subscriber)=>{
      this.socket.on('ping',(data:any) =>{
        subscriber.next(data);
      });
    });
  }

  emit(eventName: string, data: any) {
    this.socket.emit(eventName, data);
  }

  emitSendMessage(event: string, data: any, ack?: (response: any) => void): void {
    if (ack) {
      this.socket.emit(event, data, ack); // Pass the acknowledgment function to `socket.emit`
    } else {
      this.socket.emit(event, data); // Without acknowledgment
    }
  }

  disconnectSocket(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
      this.socketConnectedSubject.next(false);
      console.log('Socket completely disconnected and cleared.');
    }
  }


}
